import { Injectable, InjectionToken } from '@angular/core';

import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import {
  convertFromLocaleDate,
  convertToLocaleDate,
  getDateFromNumericFormat
} from '../date-format/date-format.helper';
import { NumericDateFormatPipe } from '../date-format/numeric-date-format.pipe';
import { EnvironmentService } from '../environment/environment.service';

export const DATEPICKER_ADAPTER = new InjectionToken<NgbDateAdapter<string>>('shrd.uic.DatepickerAdapter');

// ISO date format expected by HC cloud
export const CLOUD_DATE_FORMAT = 'yyyy-MM-dd';

/**
 * Transform from/to datepicker-internal to a custom model format, which is used outside for further processing.
 */
@Injectable()
export class DatepickerAdapterService implements NgbDateAdapter<string> {
  // preconfigured with HC date format
  private dateFormat = CLOUD_DATE_FORMAT;
  private readonly locale: string;

  constructor(envService: EnvironmentService, private readonly dateFormatPipe: NumericDateFormatPipe) {
    this.locale = envService.languageTag;
  }

  // to change the ISO default to a custom date format, if required for further data processing
  set format(format: string) {
    if (format) {
      this.dateFormat = format;
    }
  }

  get format(): string {
    return this.dateFormat;
  }

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = convertToLocaleDate(getDateFromNumericFormat(value, this.dateFormat), this.locale);
      return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? this.dateFormatPipe.transform(
          convertFromLocaleDate(new Date(date.year, date.month - 1, date.day), this.locale),
          this.dateFormat
        )
      : null;
  }
}
